import { FormattedMessage, useIntl } from 'react-intl'
import history from '../../../history'

// Utils
import { OVERLAY_HELPERS } from '../../../constants/navigation'

// Components
import { Button, Panel, Text } from '../..'
import BotHead from '../../shared/Avatar/BotHeadColored'
import OverlayPanel from '../../shared/Routing/OverlayPanel'
import SharePanel from '../SharePanel/SharePanel'

// Styles
import styles from './ShareCta.module.scss'
import { useTrackingContext } from '../../../providers/tracking'

const ShareCta = () => {
  const intl = useIntl()
  const { trackingClient } = useTrackingContext()

  return (
    <>
      <OverlayPanel
        back={OVERLAY_HELPERS.shareHomebot.getOrigin()}
        path={OVERLAY_HELPERS.shareHomebot.buildPath()}
        title={OVERLAY_HELPERS.getTitle('shareHomebot', intl.formatMessage)}
        anchorOffset={2000}
        component={SharePanel}
      />
      <Panel className={styles.card}>
        <Text element='div' align='center' variant='neutralCool' variantCount='900'>
          <BotHead quizzical size='l' />
        </Text>
        <Panel.Heading data-qa='share-homebot-bottom-digest-heading'>
          <FormattedMessage
            id='Homeowner.shareForm.heading'
            defaultMessage='Know someone who could use a Homebot report like this?'
          />
        </Panel.Heading>
        <div className={styles.btnWrapper}>
          <Button
            onClick={() => {
              trackingClient?.homebotDigestShared()
              history.push(OVERLAY_HELPERS.shareHomebot.buildPath())
            }}
            data-qa='share-homebot-bottom-digest-button'
          >
            <FormattedMessage id='Homeowner.shareSectionButton.cta' defaultMessage='Share Homebot' />
          </Button>
        </div>
      </Panel>
    </>
  )
}

export default ShareCta
